import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosRiskInstance as axios } from "axios.js";
import dayjs from "dayjs";

const INITIAL_STATE = {
  loading: false,

  filters: {
    uan: [],
    month_year: "",
    hour: []
  },

  appliedFilters: {
    uan: [],
    start_date: "",
    end_date: "",
    month_year: "",
    hour: [],
    generation_percentage: 90
  },

  date_range: {
    min_date: "",
    max_date: ""
  },

  chartData: [],
  filterStatus: false,
  isNetConsumption: true
};

// ====== INITIAL DATA FETCH ======
export const getShortTermForecastInitialDataAsync = createAsyncThunk(
  "forecast/LongTermInitial",
  async () => {
    const response = await axios.get(
      "/api/v1/solar_forecast/get_long_term_solar_forecast"
    );
    return response.data;
  }
);

// ====== FILTERED DATA FETCH ======
export const getUpdatedShortTermForecastDataAsync = createAsyncThunk(
  "forecast/LongTermUpdated",
  async ({ params }) => {
    const searchParams = new URLSearchParams();

    // Add UAN array
    params.uan?.forEach(u => searchParams.append("uan", u));

    // Add Hour array
    params.hour?.forEach(h => searchParams.append("hour", h));

    // Add Start/End Dates
    searchParams.append(
      "start_date",
      params.start_date ? dayjs(params.start_date).format("YYYY-MM-DD") : ""
    );
    searchParams.append(
      "end_date",
      params.end_date ? dayjs(params.end_date).format("YYYY-MM-DD") : ""
    );
     searchParams.append(
      "generation_percentage",
      params.generation_percentage ?? 90
    );

    const response = await axios.get(
      `/api/v1/solar_forecast/get_long_term_solar_forecast?${searchParams.toString()}`
    );

    return response.data;
  }
);

export const solarLongTermForecastSlice = createSlice({
  name: "solarLongTerm",
  initialState: INITIAL_STATE,

  reducers: {
    setAppliedFilters: (state, action) => {
      state.appliedFilters = { ...state.appliedFilters, ...action.payload };
      state.filterStatus = true;
    },
    setNetFlag: (state, action) => {
      state.isNetConsumption = action.payload;
    },
    resetFilters: (state) => {
      state.filterStatus = false;
    }
  },

  extraReducers: (builder) => {
    builder
      // ===== INITIAL =====
      .addCase(getShortTermForecastInitialDataAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getShortTermForecastInitialDataAsync.fulfilled, (state, action) => {
        state.loading = false;

        const res = action.payload;

        state.chartData = res.data || [];
        state.filters = res.filters || {};
        state.date_range = res.date_range || { min_date: "", max_date: "" };
        state.appliedFilters = res.applied_filters || {};
        state.filterStatus = false; // reset
      })
      .addCase(getShortTermForecastInitialDataAsync.rejected, (state) => {
        state.loading = false;
      })

      // ===== UPDATED =====
      .addCase(getUpdatedShortTermForecastDataAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUpdatedShortTermForecastDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.chartData = action.payload.data || [];
      })
      .addCase(getUpdatedShortTermForecastDataAsync.rejected, (state) => {
        state.loading = false;
      });
  }
});

export const { setAppliedFilters, resetFilters, setNetFlag } = solarLongTermForecastSlice.actions;
export default solarLongTermForecastSlice.reducer;
